/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{
  "rawString": ".pickerText_c7217c76{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid "
}, {
  "theme": "neutralTertiary",
  "defaultValue": "#a19f9d"
}, {
  "rawString": ";min-width:180px;min-height:30px}.pickerText_c7217c76:hover{border-color:"
}, {
  "theme": "inputBorderHovered",
  "defaultValue": "#323130"
}, {
  "rawString": "}.pickerText_c7217c76.inputFocused_c7217c76{position:relative;border-color:"
}, {
  "theme": "inputFocusBorderAlt",
  "defaultValue": "#0078d4"
}, {
  "rawString": "}.pickerText_c7217c76.inputFocused_c7217c76:after{pointer-events:none;content:'';position:absolute;left:-1px;top:-1px;bottom:-1px;right:-1px;border:2px solid "
}, {
  "theme": "inputFocusBorderAlt",
  "defaultValue": "#0078d4"
}, {
  "rawString": "}@media screen and (-ms-high-contrast:active){.pickerText_c7217c76.inputDisabled_c7217c76{position:relative;border-color:GrayText}.pickerText_c7217c76.inputDisabled_c7217c76:after{pointer-events:none;content:'';position:absolute;left:0;top:0;bottom:0;right:0;background-color:Window}}.pickerInput_c7217c76{height:34px;border:none;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;outline:0;padding:0 6px 0;-ms-flex-item-align:end;align-self:flex-end}.pickerItems_c7217c76{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:100%}.screenReaderOnly_c7217c76{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}"
}]);
export var pickerText = "pickerText_c7217c76";
export var inputFocused = "inputFocused_c7217c76";
export var inputDisabled = "inputDisabled_c7217c76";
export var pickerInput = "pickerInput_c7217c76";
export var pickerItems = "pickerItems_c7217c76";
export var screenReaderOnly = "screenReaderOnly_c7217c76";